/**
 * 权限校验指令
 * @description 用于校验当前用户是否有权限访问当前元素, 如果没有权限则移除当前元素(权限需要全部满足才显示)
 * @param {Array|String} value - 当前元素的权限标识
 */
export default {
	name: "permission",
	directive: {
		inserted(el, binding, vNode) {
			const { value } = binding;
			const permissions = vNode.context.$store.getters.permissions;

			const isArray = Array.isArray(value);
			const isString = typeof value === "string";

			// 权限类型只接受数组或字符串，其他类型直接返回（默认有权限）
			if (!value || (!isArray && !isString)) {
				return;
			}

			const currentRole = isString ? [value] : value;

			const hasPermission = currentRole.every((role) => {
				const node = role.toLowerCase();

				return permissions.includes(node);
			});

			// 如果当前用户没有权限，则移除当前元素
			if (!hasPermission) {
				el.parentNode && el.parentNode.removeChild(el);
			}
		}
	}
};
